// src/components/Navbar.js
import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import {
  AppBar,
  Toolbar,
  Box,
  Button,
  IconButton,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import MenuIcon from '@mui/icons-material/Menu'

// Import your logos
import scoutLogoLight from '../assets/scoutlogowhite.png'
import scoutLogoDark from '../assets/scoutlogoblack.png'

// Nav links
const navLinks = [

  { label: 'Contact', to: '/contact' },
]

export default function Navbar() {
  const theme = useTheme()
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)')
  const isDark = theme.palette.mode === 'dark' || prefersDark
  const logoSrc = isDark ? scoutLogoLight : scoutLogoDark

  // mobile drawer state
  const [open, setOpen] = React.useState(false)
  const toggleDrawer = () => setOpen(o => !o)

  return (
    <AppBar position="sticky" elevation={0} sx={{ backgroundColor: 'transparent' }}>
      <Toolbar sx={{ justifyContent: 'space-between', px: { xs: 2, md: 4 } }}>
        {/* LOGO */}
        <Box
          component={RouterLink}
          to="/"
          sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}
        >
          <Box component="img" src={logoSrc} alt="Scout" sx={{ height: 60 }} />
        </Box>

        {/* desktop nav + CTA */}
        <Box
          sx={{
            display: { xs: 'none', md: 'flex' },
            alignItems: 'center',
            gap: 3,
          }}
        >
          {navLinks.map(({ label, to }) => (
            <Button
              key={label}
              component={RouterLink}
              to={to}
              color="inherit"
              sx={{
                fontWeight: 600,
                textTransform: 'none',
                '&:hover': { color: 'grey.500' },
              }}
            >
              {label}
            </Button>
          ))}

          <Button
            component={RouterLink}
            to="/waitlist"
            variant="contained"
            sx={{
              backgroundColor: '#467EE5',
              color: '#fff',
              textTransform: 'none',
              fontWeight: 700,
              borderRadius: '999px',
              px: 2,
              py: 1,
              '&:hover': { backgroundColor: '#356DC7' },
            }}
          >
            Join Waitlist
          </Button>
        </Box>

        {/* mobile content link */}
        <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
          <Button
            component={RouterLink}
            to="/contact"
            color="inherit"
            sx={{
              fontWeight: 600,
              textTransform: 'none',
              fontSize: '0.9rem',
              '&:hover': { color: 'grey.500' },
            }}
          >
            Contact
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  )
}
